import { IWithChildren } from 'types';
import classNames from 'classnames';
import { useNoHeader } from 'util/useNoHeader';
import styles from './styles.module.scss';
import summerStyles from './summer-styles.module.scss';

export const BottomMountains = (
  { className, isOnSummerOverview }: Partial<IWithChildren> & { className?: string, isOnSummerOverview?: boolean },
) => {
  const { noHeader } = useNoHeader();

  const bottomMountainsStyles = isOnSummerOverview ? summerStyles.box : styles.box;

  if (noHeader) {
    return null;
  }

  return (
    <div className={classNames(bottomMountainsStyles, className)}>
      <div />
    </div>
  );
};
